import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TruckerConfirmRequest } from "../models/TruckerConfirmRequest";
import { TruckerConfirmParameters } from "../models/TruckerConfirmParameters";
import { DispatchConfirmInfo } from "../models/DispatchConfirmInfo";
import { TruckerConfirmItem } from "../models/TruckerConfirmItem";
import { TruckerConfirmResults } from "../models/TruckerConfirmResults";
import { RogerLoad } from "../models/RogerLoad";
import { TextMessage } from "../models/TextMessage";


@Injectable({
    providedIn: 'root'
})
export class TruckerConfirmationService {

    constructor(private http: HttpClient) {

    }

    getDispatchConfirmInfo(dispatchId: number): Observable<DispatchConfirmInfo> {
        return this.http.get<DispatchConfirmInfo>('api/truckerconfirm/GetDispatchConfirmInfo/' + dispatchId);
    }

    getConfirmFormData(parameters: TruckerConfirmParameters): Observable<DispatchConfirmInfo> {
        return this.http.post<DispatchConfirmInfo>('api/truckerconfirm/GetConfirmFormData', parameters);
    }

    getTruckersWithDispatches(parameters: TruckerConfirmParameters): Observable<TruckerConfirmItem[]> {
        return this.http.post<TruckerConfirmItem[]>('api/truckerconfirm/GetTruckers', parameters);
    }

    sendConfirmation(confirmRequest: TruckerConfirmRequest): Observable<TruckerConfirmResults> {
        return this.http.post<TruckerConfirmResults>('api/truckerconfirm/SendConfirmation', confirmRequest);
    }

    sendEmailConfirmation(confirmRequest: TruckerConfirmRequest): Observable<TruckerConfirmResults> {
        return this.http.post<TruckerConfirmResults>('api/truckerconfirm/SendEmailConfirmation', confirmRequest);
    }

    sendTextConfirmation(confirmRequest: TruckerConfirmRequest): Observable<TruckerConfirmResults> {
        return this.http.post<TruckerConfirmResults>('api/truckerconfirm/sendTextConfirmation', confirmRequest);
    }

    sendRogerConfirmation(confirmRequest: TruckerConfirmRequest): Observable<TruckerConfirmResults> {
        return this.http.post<TruckerConfirmResults>('api/truckerconfirm/SendRogerConfirmation', confirmRequest);
    }

    sendCompuweighConfirmation(confirmRequest: TruckerConfirmRequest): Observable<TruckerConfirmResults> {
        return this.http.post<TruckerConfirmResults>('api/truckerconfirm/SendCompuweighConfirmation', confirmRequest);
    }

    getLoadsStatus(dispatchId: number, allRecords: boolean): Observable<RogerLoad[]> {
        return this.http.get<RogerLoad[]>('api/truckerconfirm/GetLoadsStatus/' + dispatchId + '/' + allRecords);
    }

    getTextsStatus(dispatchId: number): Observable<TextMessage[]> {
        return this.http.get<TextMessage[]>('api/truckerconfirm/GetTextsStatus/' + dispatchId);
    }

    getReportContent(dispatchIds: string[], loadBreakoutOverride: boolean): Observable<Blob> {
        return this.http.post('api/truckerconfirm/GetReportContent?loadBreakoutOverride=' + loadBreakoutOverride, dispatchIds, { responseType: 'blob' });
    }
}

